/* eslint-disable react/jsx-no-undef */
import { FormHelperText, Stack } from "@mui/material";
import { MprcContainer, MprcStringToHtml } from "components";
import { AutoCompleteHierarchicalModel } from "components/MprcAutoCompleteHierarchical";
import { MprcSwitch } from "components/MprcSwitch";
import { ManagedQuestionResponse, QuestionType } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuestionContext } from "views/assessment/questionBank/Home/EditQuestion/EditQuestion";
import { QuestionGroupAutoCompleteHierarchical } from "views/assessment/questionBank/components/QuestionGroupAutoCompleteHierarchical";

////////////////////////////////////////////////////////////////////////////////

export interface IPostValidationAvailableQuestion {
    questionGroupId: string[] | undefined;
}

export interface IValidationFieldsAvailableQuestion {
    questionGroupId: boolean;
}

export function validadeAvailableQuestion(dto: ManagedQuestionResponse): IValidationFieldsAvailableQuestion {
    return {
        questionGroupId: dto.availableQuestioBank != true || (dto.questionGroupId != undefined && dto.questionGroupId.length > 0),
    };
}

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    onError: (error: any) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const EditQuestionAvailableQuestion: React.FC<IPros> = (props) => {
    const { onError } = props;
    const { viewData, postValidation, validationFields, forSurvey, readonly, editMode, handleUpdateRecord, handleUpdateEvaluation } = useQuestionContext();

    const { t } = useTranslation("assessment");

    const [questionGroup, setQuestionGroup] = useState<AutoCompleteHierarchicalModel[]>([]);

    const currentPostValidation = postValidation.available;
    const currentValidationFields = validationFields.available;
    const evaluation = viewData.evaluation;

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcContainer>
            <MprcSwitch
                label={t("Question.Edit.Available.QuestionBankLabel")}
                checked={viewData.availableQuestioBank ?? false}
                disabled={readonly}
                onChange={(e) => handleUpdateRecord("availableQuestioBank", e.target.checked)}
                helperText={t("Question.Edit.Available.QuestionBankHint")}
            />
            {
                viewData.availableQuestioBank &&
                    <Stack direction="column" ml={4} spacing={2}>
                        <QuestionGroupAutoCompleteHierarchical
                            label={t("Question.Edit.Available.QuestionGroupLabel")}
                            multiSelect={false}
                            required
                            forSurvey={forSurvey}
                            selectedItems={questionGroup}
                            onChange={(items) => {
                                setQuestionGroup(items);
                                handleUpdateRecord("questionGroupId", items.length > 0 ? items[0].key : null);
                            }}
                            onError={onError}
                            error={(viewData.questionGroupId != null && !currentValidationFields.questionGroupId) || !!currentPostValidation.questionGroupId}
                            helperText={currentPostValidation?.questionGroupId && <FormHelperText error>{<MprcStringToHtml text={currentPostValidation?.questionGroupId} />}</FormHelperText>}
                        />
                        {
                            !forSurvey &&
                             (viewData.questionType == QuestionType.SimpleChoice || viewData.questionType == QuestionType.MultipleChoice) &&
                                <MprcSwitch
                                    label={t("Question.Edit.PointOthers.AllowInKnowledgeTestsLabel")}
                                    checked={evaluation!.allowInKnowledgeTests}
                                    onChange={(e) => handleUpdateEvaluation("allowInKnowledgeTests", e.target.checked)}
                                    disabled={readonly || editMode == "challenge"}
                                    helperText={t("Question.Edit.PointOthers.AllowInKnowledgeTestsHint")}
                                />
                        }
                    </Stack>
            }
        </MprcContainer>
    );
};
